import { clearingHouseActionTypes } from './../constants/ApiConstants';

const initialState = {
  // master_data: [],
  loading: false,
  clearing_house_added: null,
  clearingHouseList: null,
  clearing_house_deleted: null,
  clearingHouseDetails: null,
  clearingHouseActiveStatus : null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  // case clearingHouseActionTypes.get_masterdata.REQUEST:
  //   return {
  //     ...state,
  //     loading: true,
  //   };
  // case clearingHouseActionTypes.get_masterdata.SUCCESS:
  //   return {
  //     ...state,
  //     loading: false,
  //     master_data: payload,
  //   };
  case clearingHouseActionTypes.get_clearinghouseList.REQUEST:
    return {
      ...state,
      loading: true,
      clearingHouseList: null,
    };
  case clearingHouseActionTypes.get_clearinghouseList.SUCCESS:
    return {
      ...state,
      loading: false,
      clearingHouseList: payload,
    };
  case clearingHouseActionTypes.get_clearinghouseDetails.REQUEST:
    return {
      ...state,
      loading: true,
      clearingHouseDetails: null,
    };
  case clearingHouseActionTypes.get_clearinghouseDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      clearingHouseDetails: payload,
    };
  case clearingHouseActionTypes.save_clearinghouseData.REQUEST:
    return {
      ...state,
      loading: true,
      clearing_house_added: null,
    };
  case clearingHouseActionTypes.save_clearinghouseData.SUCCESS:
    return {
      ...state,
      loading: false,
      clearing_house_added: payload,
    };
  case clearingHouseActionTypes.delete_clearinghouseData.REQUEST:
    return {
      ...state,
      loading: true,
      clearing_house_deleted: null,
    };
  case clearingHouseActionTypes.delete_clearinghouseData.SUCCESS:
    return {
      ...state,
      loading: false,
      clearing_house_deleted: payload,
    };
  case clearingHouseActionTypes.patch_staff_active_status.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case clearingHouseActionTypes.patch_staff_active_status.SUCCESS:
    return {
      ...state,
      clearingHouseActiveStatus: payload,
      loading: false,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/clearing-house/reducers/ClearingHouseReducers.js